module.exports = __webpack_public_path__ + "static/media/bar_chart.f8281636.svg";